import { createUseStyles } from 'react-jss'
import { smallDesktopDown } from '../../../../styles/const/breakpoints'
import { lightGrey } from '../../../../styles/const/colors'
import { transitionShort, zIndex1, zIndex3, zIndex9 } from '../../../../styles/const/common'
import { MENU_BAR } from '../../../../styles/themes/getDefaultTheme'

export const sideMenuWidth = 64
export const sideMenuExpandedWidth = 240

const useStyles = createUseStyles(theme => ({
  headerMargin: {
    height: 52
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    backgroundColor: theme[MENU_BAR].backgroundColor,
    paddingBottom: 10,
    width: ({ menuExpanded }) => (menuExpanded ? sideMenuExpandedWidth : sideMenuWidth),
    position: 'fixed',
    zIndex: zIndex9,
    top: '0',
    left: '0',
    transition: '0.2s',
    overflowX: 'hidden',
    whiteSpace: 'nowrap'
  },
  partnerLogoWrapper: {
    display: ({ displayPartnershipLogo }) => (displayPartnershipLogo ? 'flex' : 'none'),
    alignItems: 'center'
  },
  toggleBtn: {},
  overlay: {},

  [`@media screen and (${smallDesktopDown})`]: {
    header: {
      // too fix mobile styles
      height: 'initial',
      width: '100% !important',
      flexDirection: 'row',
      padding: 20,
      background: 'white',
      boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    logo: {
      padding: 0,
      width: 'auto',
      maxHeight: 32
    },
    partnerLogo: {
      maxHeight: 32
    },
    toggleBtn: {
      cursor: 'pointer',
      position: 'absolute',
      zIndex: zIndex3,
      top: 'calc(50% - 9)',
      right: 16,
      width: 25,
      height: 18,
      border: 0,
      padding: 0,
      fontSize: 0,
      outline: 'none',
      backgroundColor: 'transparent',
      '&:before, &:after': {
        content: '""'
      },
      '&:before, &:after, & span': {
        position: 'absolute',
        left: 0,
        width: 25,
        height: 2,
        borderRadius: 2,
        backgroundColor: ({ mobileMenuOpened }) => (mobileMenuOpened ? lightGrey : theme.brandPrimary),
        transition: transitionShort
      },
      '&:before': {
        top: ({ mobileMenuOpened }) => (mobileMenuOpened ? 8 : 0),
        transform: ({ mobileMenuOpened }) => (mobileMenuOpened ? 'rotate(-135deg)' : 'rotate(0deg)')
      },
      '& span': {
        top: 8,
        opacity: ({ mobileMenuOpened }) => (mobileMenuOpened ? 0 : 1)
      },
      '&:after': {
        top: ({ mobileMenuOpened }) => (mobileMenuOpened ? 8 : 16),
        transform: ({ mobileMenuOpened }) => (mobileMenuOpened ? 'rotate(135deg)' : 'rotate(0deg)')
      }
    },
    overlay: {
      position: 'fixed',
      zIndex: zIndex1,
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,.6)',
      transition: transitionShort,
      opacity: ({ mobileMenuOpened }) => (mobileMenuOpened ? 1 : 0),
      pointerEvents: ({ mobileMenuOpened }) => (mobileMenuOpened ? 'all' : 'none')
    }
  }
}))

export default useStyles
